import { combineReducers } from "redux";
import organisationReducer from "../reducers/organisationReducer";
import userReducer from "../reducers/userReducer";
import inviteReducer from "../reducers/inviteTemplateReducer";
import snackbarReducer from "shared/redux/reducers/SnackbarReducer";

export default combineReducers({
    organisation: organisationReducer,
    user: userReducer,
    invite: inviteReducer,
    snackbar: snackbarReducer
});